import { NavLink, useParams } from "react-router-dom";
import { Divider, Tag } from "antd";
// import { BiLeftArrowAlt, BiRightArrowAlt } from "react-icons/bi";
import weddingBlogs from "../Component/weddingBlogs";
import moment from "moment";

export default function BlogView() {
  const { id } = useParams();

  const data = weddingBlogs.find((val) => val.slug === id);

  return (
    data && (
      <>
        <section className="section">
          <div className="container mx-auto sm:px-5 xl:px-0">
            <div className="row">
              <div className="col-12 col-lg-7">
                <div className="section-body-left">
                  <h1 className="section-title" style={{ textAlign: "left" }}>
                    {data?.title}
                  </h1>
                  <img
                    className="my-5"
                    src={
                      data?.image ??
                      "https://find-company-online.co.uk/uploads/images/no-thumb.png"
                    }
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop
                      e.target.src =
                        "https://find-company-online.co.uk/uploads/images/no-thumb.png";
                    }}
                    style={{
                      maxHeight: 400,
                      width: "100%",
                      objectFit: "cover",
                      borderRadius: 10,
                    }}
                  />

                  <div
                    className="section-content"
                    style={{ textAlign: "left" }}
                    dangerouslySetInnerHTML={{ __html: data?.html_description }}
                  ></div>
                </div>

                {/* <Divider /> */}

                {/* <div className="next-previous-button flex justify-between">
                  <Button className="comman-button">
                    <BiLeftArrowAlt />
                    Previous
                  </Button>
                  <Button className="comman-button">
                    Next
                    <BiRightArrowAlt />
                  </Button>
                </div> */}
              </div>

              <div className="col-12 col-lg-5">
                <div className="sticky top-25">
                  <h2 style={{ fontSize: "1.8rem" }}>Related Blogs</h2>
                  <Divider />
                  <div className="blogs-list">
                    {weddingBlogs.slice(1).map((blog, index) => (
                      <BlogCard key={index} data={blog} />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    )
  );
}

const BlogCard = ({ data }) => (
  <div className="home-blog-card-main-con">
    <div
      className="home-blog-card-image-main-con"
      style={{
        backgroundImage: `url(${
          data.blogImage ??
          "https://find-company-online.co.uk/uploads/images/no-thumb.png"
        })`,
      }}
    >
      {/* Display the image */}
      <div className="home-blog-card-image-overlay-date">
        <span>{moment(new Date()).format("DD MMM YY")}</span>
      </div>
    </div>
    <div className="home-blog-card-image-details-main-con" style={{ textAlign: "left" }}>
      <h4 style={{fontSize:"1rem"}}>{data.title}</h4>
      {/* Access the blogtitle property */}
      {/* Access the blogName property */}
      <p>{data.short_description}</p>
      {/* Access the blogshortDes property */}
      <NavLink
        to={"/view/"+data.slug}
        style={{ textAlign: "left" }}
        className="home-blog-card-details-btn"
      >
        <button className="btn">Read More</button>
      </NavLink>
    </div>
  </div>
);
